/**
 * Import api
 */
import api from '../../api';


/**
 * Define state
 * @type {{currentUserInfo: null, isAuthenticated: boolean}}
 */
const state = {
    recruitmentList: []
};


/**
 * Define getters
 * @type {{}}
 */
const getters = {

};


/**
 * Define actions
 * @type {{}}
 */
const actions = {
    /**
     * Get recruitment list
     * @param commit
     * @param currentPage
     * @returns {Promise<void>}
     */
    async getAllRecruitmentList({commit}) {
        await api.getAllRecruitmentList()
            .then((response) => {
                commit('GET_RECRUITMENT_LIST_SUCCESSFULLY', response.data);
            })
    }
};


/**
 * Define mutations
 * @type {{}}
 */
const mutations = {

    /**
     * Get recruitment successfully
     * @param state
     * @param data
     * @constructor
     */
    GET_RECRUITMENT_LIST_SUCCESSFULLY(state, data) {
        state.recruitmentList = data.data;
    }
};


/**
 * Export module
 */
export default {
    state,
    getters,
    actions,
    mutations
}
